import React from "react"
import styled from "styled-components"

const StyledFooter = styled.footer`
  width: 100vw;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  /* margin: auto; */
  margin-top: auto;
  text-align: center;
  font-size: small;
  color: gray;
  background: #0b1622;
`

const Footer = () => {
  return (
    <StyledFooter>
      © {new Date().getFullYear()}, Designed & Built by Akira Suto
    </StyledFooter>
  )
}

export default Footer
